import styled from "styled-components";
import {color} from "../../../../shared/styles";

export const TableTitle = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    border-left: 5px solid var(--Primary-Blue-B100, #0058a0);
    padding-left: 20px;
    margin-bottom: 8px;
`;

export const TableItemCounter = styled.span`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: ${color.secondary.DARK_GREY};
`

export const ProviderButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
`